import React from "react"
import { Button, ButtonGroup, Label } from "reactstrap"
import EcosuiteComponent from "@common/EcosuiteComponent"
import i18n from "src/i18n"
import ToolsService from "@common/utils/ToolsService"

const { t } = i18n
class AddressLookup extends EcosuiteComponent {
  constructor(props) {
    super(props)
    this.getGeocoder = this.getGeocoder.bind(this)
    this.clickHandler = this.clickHandler.bind(this)
    this.getLatLong = this.getLatLong.bind(this)
  }

  getLatLong(_address) {
    this.getGeocoder().geocode({ address: _address }, async (results) => {
      if (results && results.length > 0) {
        const latLong = results[0].geometry.location
        const components = results[0].address_components
        const town = components.find((component) => component.types.includes("locality"))
        const state = components.find((component) => component.types.includes("administrative_area_level_1"))

        const timezone = await ToolsService.getTimezoneForLatLong(latLong.lat(), latLong.lng())

        this.setStateIfMounted({ error: null })
        this.props.gotAddress({
          address: results[0].formatted_address,
          town: town ? town.long_name : null,
          state: state ? state.long_name : null,
          latitude: Number(latLong.lat().toFixed(7)),
          longitude: Number(latLong.lng().toFixed(7)),
          timezone: timezone.timeZoneId,
        })
      } else {
        this.setStateIfMounted({ error: `${t("errors.Address not found")}` })
        this.props.gotAddress(null)
      }
    })
  }

  getGeocoder() {
    if (this.geocoder) {
      return this.geocoder
    }
    if (window.google && window.google.maps) {
      this.geocoder = new window.google.maps.Geocoder()
    }
    return this.geocoder
  }

  clickHandler() {
    this.getLatLong(this.props.getAddress())
  }

  renderContent() {
    const formData = this.props.formData

    return (
      <div>
        <ButtonGroup>
          <Button color="primary" onClick={this.clickHandler} disabled={this.props.disabled}>
            {t("buttons.look_up_address")}
          </Button>
          <Button
            color="primary"
            onClick={() => {
              window.open(`https://www.google.com/maps/@${formData?.lat},${formData?.long},15z`)
            }}
            disabled={this.props.disabled}
          >
            View Map
          </Button>
        </ButtonGroup>
        <Label>{this.state.error}</Label>
      </div>
    )
  }
}

export default AddressLookup
